export default "__VITE_ASSET__CLY12o5H__"